export const bankConnectionsTranslations: Record<string, {
  title: string;
  description: string;
  edit: string;
  updated_today_at: string;
  consent_created_at: string;
  consent_expires_at: string;
  consent_reconfirmed_at: string;
  authorization_pending_title: string;
  authorization_pending_description: string;
  authorization_expires_at: string;
  authorization_expired: string;
  continue_authorization: string;
  retry_authorization: string;
  retry_authorization_loading: string;
  retry_authorization_failed: string;
  authorization_missing_link: string;
  authorization_rejected_title: string;
  authorization_rejected_description: string;
  authorization_details_cta: string;
  authorization_details_title: string;
  authorization_details_description: string;
  authorization_details_status: string;
  authorization_details_consent_id: string;
  authorization_details_institution_consent_id: string;
  authorization_details_tracing_id: string;
  authorization_details_phases: string;
  authorization_details_no_phases: string;
  authorization_details_loading: string;
  authorization_details_close: string;
  authorization_details_failed: string;
  revoke_consent: string;
  revoke_consent_title: string;
  revoke_consent_description: string;
  revoke_consent_confirm: string;
  revoke_consent_cancel: string;
  revoke_consent_success: string;
  revoke_consent_failed: string;
  connection_requires_reauth: string;
  please_update: string;
  review_entries: string;
  update: string;
  new_bank_connection: string;
  list_of_supported_connections: string;
  yapily_connection_dashboard: string;
  about_openbanking: string;
  about_openbanking_description: string;
  no_bank_connections_title: string;
  no_bank_connections_description: string;
  accounts_title: string;
  account_default_name: string;
  account_name_placeholder: string;
  account_name_save: string;
  account_name_cancel: string;
  account_name_rename: string;
  account_name_saved: string;
  account_name_failed: string;
  account_visibility_label: string;
  account_visibility_hidden: string;
  account_visibility_saved: string;
  account_visibility_failed: string;
  limit_reached: string;
  upgrade: string;
}> = {
  pt: {
    title: "Ligações Bancárias",
    description: "Gerir as suas contas bancárias conectadas via OpenBanking",
    edit: "EDITAR",
    updated_today_at: "Atualizado hoje às",
    consent_created_at: "Consentimento criado",
    consent_expires_at: "Consentimento expira",
    consent_reconfirmed_at: "Reconfirmado em",
    authorization_pending_title: "Autorização pendente",
    authorization_pending_description:
      "Complete o consentimento na app do banco ou no desktop.",
    authorization_expires_at: "Expira às",
    authorization_expired: "Pedido expirado.",
    continue_authorization: "Continuar autorização",
    retry_authorization: "Tentar novamente",
    retry_authorization_loading: "A iniciar...",
    retry_authorization_failed: "Não foi possível iniciar a autorização.",
    authorization_missing_link: "O link de autorização não está disponível.",
    authorization_rejected_title: "Autorização rejeitada",
    authorization_rejected_description:
      "O banco rejeitou o pedido de consentimento. Pode tentar novamente.",
    authorization_details_cta: "Ver detalhes",
    authorization_details_title: "Detalhes da autorização",
    authorization_details_description:
      "Informação técnica da Yapily para esta tentativa de consentimento.",
    authorization_details_status: "Estado",
    authorization_details_consent_id: "ID do consentimento",
    authorization_details_institution_consent_id: "ID do consentimento no banco",
    authorization_details_tracing_id: "Tracing ID",
    authorization_details_phases: "Fases",
    authorization_details_no_phases: "Sem fases registadas.",
    authorization_details_loading: "A carregar detalhes...",
    authorization_details_close: "Fechar",
    authorization_details_failed: "Não foi possível obter os detalhes.",
    revoke_consent: "Anular consentimento",
    revoke_consent_title: "Anular consentimento?",
    revoke_consent_description:
      "Isto revoga o acesso do MoneyLights à sua conta bancária. Pode voltar a ligar quando quiser.",
    revoke_consent_confirm: "Anular",
    revoke_consent_cancel: "Cancelar",
    revoke_consent_success: "Consentimento anulado.",
    revoke_consent_failed: "Não foi possível anular o consentimento.",
    connection_requires_reauth: "Esta ligação requer uma re-autorização regular.",
    please_update: "Por favor atualize para continuar a importar dados.",
    review_entries: "Rever entradas",
    update: "Atualizar",
    new_bank_connection: "Nova ligação bancária",
    list_of_supported_connections: "Lista de ligações suportadas",
    yapily_connection_dashboard: "Painel de ligações Yapily",
    about_openbanking: "Sobre OpenBanking",
    about_openbanking_description:
      "OpenBanking permite-lhe conectar de forma segura as suas contas bancárias ao MoneyLights. Todas as ligações são encriptadas e seguem os mais altos padrões de segurança (PSD2). Utilizamos Yapily como o nosso fornecedor de OpenBanking para garantir que os seus dados estão sempre seguros e atualizados.",
    no_bank_connections_title: "Sem ligações bancárias",
    no_bank_connections_description:
      "Ligue a sua conta bancária via OpenBanking para importar e analisar automaticamente as suas transações.",
    accounts_title: "Contas",
    account_default_name: "Conta bancária",
    account_name_placeholder: "Nome da conta",
    account_name_save: "Guardar",
    account_name_cancel: "Cancelar",
    account_name_rename: "Renomear",
    account_name_saved: "Nome da conta atualizado.",
    account_name_failed: "Não foi possível atualizar o nome.",
    account_visibility_label: "Visível na app",
    account_visibility_hidden: "Oculta",
    account_visibility_saved: "Visibilidade da conta atualizada.",
    account_visibility_failed: "Não foi possível atualizar a visibilidade da conta.",
    limit_reached: "Limite de ligações bancárias atingido",
    upgrade: "Fazer upgrade",
  },
  en: {
    title: "Bank Connections",
    description: "Manage your bank accounts connected via OpenBanking",
    edit: "EDIT",
    updated_today_at: "Updated today at",
    consent_created_at: "Consent created",
    consent_expires_at: "Consent expires",
    consent_reconfirmed_at: "Reconfirmed on",
    authorization_pending_title: "Authorization pending",
    authorization_pending_description:
      "Complete the consent in your bank app or on desktop.",
    authorization_expires_at: "Expires at",
    authorization_expired: "Request expired.",
    continue_authorization: "Continue authorization",
    retry_authorization: "Try again",
    retry_authorization_loading: "Starting...",
    retry_authorization_failed: "Failed to start authorization.",
    authorization_missing_link: "Authorization link is unavailable.",
    authorization_rejected_title: "Authorization rejected",
    authorization_rejected_description:
      "Your bank rejected the consent request. You can try again.",
    authorization_details_cta: "View details",
    authorization_details_title: "Authorization details",
    authorization_details_description:
      "Yapily technical info for this consent attempt.",
    authorization_details_status: "Status",
    authorization_details_consent_id: "Consent ID",
    authorization_details_institution_consent_id: "Institution consent ID",
    authorization_details_tracing_id: "Tracing ID",
    authorization_details_phases: "Phases",
    authorization_details_no_phases: "No phases recorded.",
    authorization_details_loading: "Loading details...",
    authorization_details_close: "Close",
    authorization_details_failed: "Failed to load details.",
    revoke_consent: "Revoke consent",
    revoke_consent_title: "Revoke consent?",
    revoke_consent_description:
      "This will revoke MoneyLights access to your bank account. You can reconnect at any time.",
    revoke_consent_confirm: "Revoke",
    revoke_consent_cancel: "Cancel",
    revoke_consent_success: "Consent revoked.",
    revoke_consent_failed: "Failed to revoke consent.",
    connection_requires_reauth: "This connection requires regular reauthorization.",
    please_update: "Please update to continue importing data.",
    review_entries: "Review entries",
    update: "Update",
    new_bank_connection: "New bank connection",
    list_of_supported_connections: "List of supported connections",
    yapily_connection_dashboard: "Yapily connection dashboard",
    about_openbanking: "About OpenBanking",
    about_openbanking_description:
      "OpenBanking allows you to securely connect your bank accounts to MoneyLights. All connections are encrypted and follow the highest security standards (PSD2). We use Yapily as our OpenBanking provider to ensure your data is always secure and up-to-date.",
    no_bank_connections_title: "No bank connections",
    no_bank_connections_description:
      "Connect your bank account via Open Banking to automatically import and analyze your transactions.",
    accounts_title: "Accounts",
    account_default_name: "Bank account",
    account_name_placeholder: "Account name",
    account_name_save: "Save",
    account_name_cancel: "Cancel",
    account_name_rename: "Rename",
    account_name_saved: "Account name updated.",
    account_name_failed: "Failed to update account name.",
    account_visibility_label: "Visible in app",
    account_visibility_hidden: "Hidden",
    account_visibility_saved: "Account visibility updated.",
    account_visibility_failed: "Failed to update account visibility.",
    limit_reached: "Bank connections limit reached",
    upgrade: "Upgrade",
  },
  es: {
    title: "Conexiones Bancarias",
    description: "Administrar tus cuentas bancarias conectadas a través de OpenBanking",
    edit: "EDITAR",
    updated_today_at: "Actualizado hoy a las",
    consent_created_at: "Consentimiento creado",
    consent_expires_at: "El consentimiento expira",
    consent_reconfirmed_at: "Reconfirmado el",
    authorization_pending_title: "Autorización pendiente",
    authorization_pending_description:
      "Completa el consentimiento en la app del banco o en el escritorio.",
    authorization_expires_at: "Caduca a las",
    authorization_expired: "Solicitud caducada.",
    continue_authorization: "Continuar autorización",
    retry_authorization: "Intentar de nuevo",
    retry_authorization_loading: "Iniciando...",
    retry_authorization_failed: "No se pudo iniciar la autorización.",
    authorization_missing_link: "El enlace de autorización no está disponible.",
    authorization_rejected_title: "Autorización rechazada",
    authorization_rejected_description:
      "El banco rechazó la solicitud de consentimiento. Puedes intentarlo de nuevo.",
    authorization_details_cta: "Ver detalles",
    authorization_details_title: "Detalles de autorización",
    authorization_details_description:
      "Información técnica de Yapily para este intento de consentimiento.",
    authorization_details_status: "Estado",
    authorization_details_consent_id: "ID del consentimiento",
    authorization_details_institution_consent_id: "ID del consentimiento del banco",
    authorization_details_tracing_id: "Tracing ID",
    authorization_details_phases: "Fases",
    authorization_details_no_phases: "Sin fases registradas.",
    authorization_details_loading: "Cargando detalles...",
    authorization_details_close: "Cerrar",
    authorization_details_failed: "No se pudieron obtener los detalles.",
    revoke_consent: "Revocar consentimiento",
    revoke_consent_title: "¿Revocar consentimiento?",
    revoke_consent_description:
      "Esto revocará el acceso de MoneyLights a tu cuenta bancaria. Puedes volver a conectar cuando quieras.",
    revoke_consent_confirm: "Revocar",
    revoke_consent_cancel: "Cancelar",
    revoke_consent_success: "Consentimiento revocado.",
    revoke_consent_failed: "No se pudo revocar el consentimiento.",
    connection_requires_reauth: "Esta conexión requiere una reautenticación regular.",
    please_update: "Por favor, actualiza para continuar importando datos.",
    review_entries: "Revisar entradas",
    update: "Actualizar",
    new_bank_connection: "Nueva conexión bancaria",
    list_of_supported_connections: "Lista de conexiones soportadas",
    yapily_connection_dashboard: "Panel de conexiones Yapily",
    about_openbanking: "Sobre OpenBanking",
    about_openbanking_description:
      "OpenBanking te permite conectar de forma segura tus cuentas bancarias a MoneyLights. Todas las conexiones están encriptadas y siguen los más altos estándares de seguridad (PSD2). Utilizamos Yapily como proveedor de OpenBanking para asegurarnos de que tus datos siempre estén seguros y actualizados.",
    no_bank_connections_title: "Sin conexiones bancarias",
    no_bank_connections_description:
      "Conecta tu cuenta bancaria vía OpenBanking para importar y analizar automáticamente tus transacciones.",
    accounts_title: "Cuentas",
    account_default_name: "Cuenta bancaria",
    account_name_placeholder: "Nombre de la cuenta",
    account_name_save: "Guardar",
    account_name_cancel: "Cancelar",
    account_name_rename: "Renombrar",
    account_name_saved: "Nombre de cuenta actualizado.",
    account_name_failed: "No se pudo actualizar el nombre de la cuenta.",
    account_visibility_label: "Visible en la app",
    account_visibility_hidden: "Oculta",
    account_visibility_saved: "Visibilidad de la cuenta actualizada.",
    account_visibility_failed: "No se pudo actualizar la visibilidad de la cuenta.",
    limit_reached: "Límite de conexiones bancarias alcanzado",
    upgrade: "Mejorar",
  },
  et: {
    title: "Pangaühendused",
    description: "Haldage oma pangakontodeid, mis on ühendatud OpenBanking'i kaudu",
    edit: "MUUDA",
    updated_today_at: "Värskendatud tänasena kell",
    consent_created_at: "Nõusolek loodud",
    consent_expires_at: "Nõusolek aegub",
    consent_reconfirmed_at: "Taaskinnitatud",
    authorization_pending_title: "Autentimine ootel",
    authorization_pending_description:
      "Lõpeta nõusolek panga äpis või töölaual.",
    authorization_expires_at: "Aegub kell",
    authorization_expired: "Taotlus aegus.",
    continue_authorization: "Jätka autentimist",
    retry_authorization: "Proovi uuesti",
    retry_authorization_loading: "Käivitan...",
    retry_authorization_failed: "Autentimise käivitamine ebaõnnestus.",
    authorization_missing_link: "Autentimislink pole saadaval.",
    authorization_rejected_title: "Autentimine tagasi lükatud",
    authorization_rejected_description:
      "Pank lükkas nõusoleku taotluse tagasi. Võid uuesti proovida.",
    authorization_details_cta: "Vaata detaile",
    authorization_details_title: "Autentimise üksikasjad",
    authorization_details_description:
      "Yapily tehniline info selle nõusoleku katse kohta.",
    authorization_details_status: "Staatus",
    authorization_details_consent_id: "Nõusoleku ID",
    authorization_details_institution_consent_id: "Panga nõusoleku ID",
    authorization_details_tracing_id: "Tracing ID",
    authorization_details_phases: "Faase",
    authorization_details_no_phases: "Faasid puuduvad.",
    authorization_details_loading: "Laadin üksikasju...",
    authorization_details_close: "Sulge",
    authorization_details_failed: "Üksikasju ei õnnestunud laadida.",
    revoke_consent: "Tühista nõusolek",
    revoke_consent_title: "Kas tühistada nõusolek?",
    revoke_consent_description:
      "See tühistab MoneyLightsi juurdepääsu sinu pangakontole. Saad soovi korral uuesti ühendada.",
    revoke_consent_confirm: "Tühista",
    revoke_consent_cancel: "Loobu",
    revoke_consent_success: "Nõusolek tühistatud.",
    revoke_consent_failed: "Nõusoleku tühistamine ebaõnnestus.",
    connection_requires_reauth: "See ühendus nõuab regulaarset uuesti autentimist.",
    please_update: "Palun värskendage, et jätkata andmete importimist.",
    review_entries: "Vaadake kirjeid üle",
    update: "Värskenda",
    new_bank_connection: "Uus pangakontoühendus",
    list_of_supported_connections: "Toetatud ühenduste loend",
    yapily_connection_dashboard: "Yapily ühenduste paneel",
    about_openbanking: "OpenBanking kohta",
    about_openbanking_description:
      "OpenBanking võimaldab teil turvaliselt ühendada oma pangakontoja MoneyLightsiga. Kõik ühendused on krüpteeritud ja järgivad kõige kõrgemaid turvalisuse standarde (PSD2). Kasutame Yapilyt OpenBanking pakkuja kui turvalisuse ja andmete uuendamise tagamiseks.",
    no_bank_connections_title: "Pangaühendusi pole",
    no_bank_connections_description:
      "Ühendage oma pangakonto OpenBankingi kaudu, et importida ja analüüsida tehinguid automaatselt.",
    accounts_title: "Kontod",
    account_default_name: "Pangakonto",
    account_name_placeholder: "Konto nimi",
    account_name_save: "Salvesta",
    account_name_cancel: "Tühista",
    account_name_rename: "Muuda nime",
    account_name_saved: "Konto nimi uuendatud.",
    account_name_failed: "Konto nime uuendamine ebaõnnestus.",
    account_visibility_label: "Rakenduses nähtav",
    account_visibility_hidden: "Peidetud",
    account_visibility_saved: "Konto nähtavus uuendatud.",
    account_visibility_failed: "Konto nähtavust ei õnnestunud uuendada.",
    limit_reached: "Pangaühenduste limiit täis",
    upgrade: "Uuenda",
  },
  de: {
    title: "Bankverbindungen",
    description: "Verwalten Sie Ihre Bankkonten via OpenBanking",
    edit: "BEARBEITEN",
    updated_today_at: "Heute aktualisiert um",
    consent_created_at: "Einwilligung erstellt",
    consent_expires_at: "Einwilligung läuft ab",
    consent_reconfirmed_at: "Bestätigt am",
    authorization_pending_title: "Autorisierung ausstehend",
    authorization_pending_description:
      "Schließe die Einwilligung in der Banking-App oder am Desktop ab.",
    authorization_expires_at: "Läuft ab um",
    authorization_expired: "Anfrage abgelaufen.",
    continue_authorization: "Autorisierung fortsetzen",
    retry_authorization: "Erneut versuchen",
    retry_authorization_loading: "Starte...",
    retry_authorization_failed: "Autorisierung konnte nicht gestartet werden.",
    authorization_missing_link: "Autorisierungslink ist nicht verfügbar.",
    authorization_rejected_title: "Autorisierung abgelehnt",
    authorization_rejected_description:
      "Die Bank hat die Einwilligung abgelehnt. Du kannst es erneut versuchen.",
    authorization_details_cta: "Details anzeigen",
    authorization_details_title: "Autorisierungsdetails",
    authorization_details_description:
      "Technische Yapily-Informationen zu diesem Einwilligungsversuch.",
    authorization_details_status: "Status",
    authorization_details_consent_id: "Einwilligungs-ID",
    authorization_details_institution_consent_id: "Bank-Einwilligungs-ID",
    authorization_details_tracing_id: "Tracing ID",
    authorization_details_phases: "Phasen",
    authorization_details_no_phases: "Keine Phasen vorhanden.",
    authorization_details_loading: "Details werden geladen...",
    authorization_details_close: "Schließen",
    authorization_details_failed: "Details konnten nicht geladen werden.",
    revoke_consent: "Einwilligung widerrufen",
    revoke_consent_title: "Einwilligung widerrufen?",
    revoke_consent_description:
      "Dadurch wird der Zugriff von MoneyLights auf dein Bankkonto widerrufen. Du kannst jederzeit erneut verbinden.",
    revoke_consent_confirm: "Widerrufen",
    revoke_consent_cancel: "Abbrechen",
    revoke_consent_success: "Einwilligung widerrufen.",
    revoke_consent_failed: "Einwilligung konnte nicht widerrufen werden.",
    connection_requires_reauth: "Diese Verbindung erfordert regelmäßige Autorisierung.",
    please_update: "Bitte aktualisieren Sie, um Daten zu importieren.",
    review_entries: "Einträge überprüfen",
    update: "Aktualisieren",
    new_bank_connection: "Neue Bankverbindung",
    list_of_supported_connections: "Liste unterstützter Verbindungen",
    yapily_connection_dashboard: "Yapily-Dashboard",
    about_openbanking: "Über OpenBanking",
    about_openbanking_description:
      "OpenBanking ermöglicht sichere Verbindung Ihrer Bankkonten mit MoneyLights. Alle Verbindungen sind verschlüsselt und folgen höchsten Sicherheitsstandards (PSD2).",
    no_bank_connections_title: "Keine Bankverbindungen",
    no_bank_connections_description:
      "Verbinden Sie Ihr Bankkonto über OpenBanking, um Transaktionen automatisch zu importieren und zu analysieren.",
    accounts_title: "Konten",
    account_default_name: "Bankkonto",
    account_name_placeholder: "Kontoname",
    account_name_save: "Speichern",
    account_name_cancel: "Abbrechen",
    account_name_rename: "Umbenennen",
    account_name_saved: "Kontoname aktualisiert.",
    account_name_failed: "Kontoname konnte nicht aktualisiert werden.",
    account_visibility_label: "In der App sichtbar",
    account_visibility_hidden: "Ausgeblendet",
    account_visibility_saved: "Kontosichtbarkeit aktualisiert.",
    account_visibility_failed: "Kontosichtbarkeit konnte nicht aktualisiert werden.",
    limit_reached: "Bankverbindungs-Limit erreicht",
    upgrade: "Aktualisieren",
  },
  fr: {
    title: "Connexions Bancaires",
    description: "Gérer vos comptes bancaires via OpenBanking",
    edit: "MODIFIER",
    updated_today_at: "Mis à jour aujourd'hui à",
    consent_created_at: "Consentement créé",
    consent_expires_at: "Consentement expire",
    consent_reconfirmed_at: "Reconfirmé le",
    authorization_pending_title: "Autorisation en attente",
    authorization_pending_description:
      "Terminez le consentement dans l'application bancaire ou sur desktop.",
    authorization_expires_at: "Expire à",
    authorization_expired: "Demande expirée.",
    continue_authorization: "Continuer l'autorisation",
    retry_authorization: "Réessayer",
    retry_authorization_loading: "Démarrage...",
    retry_authorization_failed: "Impossible de démarrer l'autorisation.",
    authorization_missing_link: "Le lien d'autorisation n'est pas disponible.",
    authorization_rejected_title: "Autorisation refusée",
    authorization_rejected_description:
      "La banque a refusé la demande de consentement. Vous pouvez réessayer.",
    authorization_details_cta: "Voir les détails",
    authorization_details_title: "Détails d'autorisation",
    authorization_details_description:
      "Informations techniques Yapily pour cette tentative de consentement.",
    authorization_details_status: "Statut",
    authorization_details_consent_id: "ID de consentement",
    authorization_details_institution_consent_id: "ID de consentement de la banque",
    authorization_details_tracing_id: "Tracing ID",
    authorization_details_phases: "Phases",
    authorization_details_no_phases: "Aucune phase enregistrée.",
    authorization_details_loading: "Chargement des détails...",
    authorization_details_close: "Fermer",
    authorization_details_failed: "Impossible de charger les détails.",
    revoke_consent: "Révoquer le consentement",
    revoke_consent_title: "Révoquer le consentement ?",
    revoke_consent_description:
      "Cela révoquera l'accès de MoneyLights à votre compte bancaire. Vous pourrez vous reconnecter à tout moment.",
    revoke_consent_confirm: "Révoquer",
    revoke_consent_cancel: "Annuler",
    revoke_consent_success: "Consentement révoqué.",
    revoke_consent_failed: "Impossible de révoquer le consentement.",
    connection_requires_reauth: "Cette connexion nécessite une ré-autorisation régulière.",
    please_update: "Veuillez mettre à jour pour continuer à importer des données.",
    review_entries: "Réviser les entrées",
    update: "Mettre à jour",
    new_bank_connection: "Nouvelle connexion bancaire",
    list_of_supported_connections: "Liste des connexions prises en charge",
    yapily_connection_dashboard: "Tableau de bord Yapily",
    about_openbanking: "À propos d'OpenBanking",
    about_openbanking_description:
      "OpenBanking vous permet de connecter en toute sécurité vos comptes bancaires à MoneyLights. Toutes les connexions sont cryptées et suivent les normes de sécurité les plus élevées (PSD2).",
    no_bank_connections_title: "Aucune connexion bancaire",
    no_bank_connections_description:
      "Connectez votre compte bancaire via OpenBanking pour importer et analyser automatiquement vos transactions.",
    accounts_title: "Comptes",
    account_default_name: "Compte bancaire",
    account_name_placeholder: "Nom du compte",
    account_name_save: "Enregistrer",
    account_name_cancel: "Annuler",
    account_name_rename: "Renommer",
    account_name_saved: "Nom du compte mis à jour.",
    account_name_failed: "Impossible de mettre à jour le nom du compte.",
    account_visibility_label: "Visible dans l’app",
    account_visibility_hidden: "Masquée",
    account_visibility_saved: "Visibilité du compte mise à jour.",
    account_visibility_failed: "Impossible de mettre à jour la visibilité du compte.",
    limit_reached: "Limite de connexions bancaires atteint",
    upgrade: "Mettre à niveau",
  },
  it: {
    title: "Connessioni Bancarie",
    description: "Gestire i conti bancari tramite OpenBanking",
    edit: "MODIFICA",
    updated_today_at: "Aggiornato oggi alle",
    consent_created_at: "Consenso creato",
    consent_expires_at: "Consenso scade",
    consent_reconfirmed_at: "Riconfermato il",
    authorization_pending_title: "Autorizzazione in sospeso",
    authorization_pending_description:
      "Completa il consenso nell'app bancaria o su desktop.",
    authorization_expires_at: "Scade alle",
    authorization_expired: "Richiesta scaduta.",
    continue_authorization: "Continua autorizzazione",
    retry_authorization: "Riprova",
    retry_authorization_loading: "Avvio...",
    retry_authorization_failed: "Impossibile avviare l'autorizzazione.",
    authorization_missing_link: "Il link di autorizzazione non è disponibile.",
    authorization_rejected_title: "Autorizzazione rifiutata",
    authorization_rejected_description:
      "La banca ha rifiutato la richiesta di consenso. Puoi riprovare.",
    authorization_details_cta: "Vedi dettagli",
    authorization_details_title: "Dettagli autorizzazione",
    authorization_details_description:
      "Informazioni tecniche Yapily per questo tentativo di consenso.",
    authorization_details_status: "Stato",
    authorization_details_consent_id: "ID del consenso",
    authorization_details_institution_consent_id: "ID del consenso della banca",
    authorization_details_tracing_id: "Tracing ID",
    authorization_details_phases: "Fasi",
    authorization_details_no_phases: "Nessuna fase registrata.",
    authorization_details_loading: "Caricamento dettagli...",
    authorization_details_close: "Chiudi",
    authorization_details_failed: "Impossibile caricare i dettagli.",
    revoke_consent: "Revoca consenso",
    revoke_consent_title: "Revocare il consenso?",
    revoke_consent_description:
      "Questo revoca l'accesso di MoneyLights al tuo conto bancario. Puoi riconnetterti in qualsiasi momento.",
    revoke_consent_confirm: "Revoca",
    revoke_consent_cancel: "Annulla",
    revoke_consent_success: "Consenso revocato.",
    revoke_consent_failed: "Impossibile revocare il consenso.",
    connection_requires_reauth: "Questa connessione richiede riautorizzazione regolare.",
    please_update: "Aggiorna per continuare a importare dati.",
    review_entries: "Rivedi le voci",
    update: "Aggiorna",
    new_bank_connection: "Nuova connessione bancaria",
    list_of_supported_connections: "Elenco connessioni supportate",
    yapily_connection_dashboard: "Dashboard Yapily",
    about_openbanking: "Informazioni su OpenBanking",
    about_openbanking_description:
      "OpenBanking consente di connettere in sicurezza i conti bancari a MoneyLights. Tutte le connessioni sono crittografate e seguono i massimi standard di sicurezza (PSD2).",
    no_bank_connections_title: "Nessuna connessione bancaria",
    no_bank_connections_description:
      "Collega il tuo conto bancario tramite OpenBanking per importare e analizzare automaticamente le transazioni.",
    accounts_title: "Conti",
    account_default_name: "Conto bancario",
    account_name_placeholder: "Nome del conto",
    account_name_save: "Salva",
    account_name_cancel: "Annulla",
    account_name_rename: "Rinomina",
    account_name_saved: "Nome del conto aggiornato.",
    account_name_failed: "Impossibile aggiornare il nome del conto.",
    account_visibility_label: "Visibile nell’app",
    account_visibility_hidden: "Nascosto",
    account_visibility_saved: "Visibilità del conto aggiornata.",
    account_visibility_failed: "Impossibile aggiornare la visibilità del conto.",
    limit_reached: "Limite di connessioni bancarie raggiunto",
    upgrade: "Aggiorna",
  },
  nl: {
    title: "Bankverbindingen",
    description: "Beheer uw bankrekeningen via OpenBanking",
    edit: "BEWERKEN",
    updated_today_at: "Vandaag bijgewerkt om",
    consent_created_at: "Toestemming aangemaakt",
    consent_expires_at: "Toestemming verloopt",
    consent_reconfirmed_at: "Opnieuw bevestigd op",
    authorization_pending_title: "Autorisatie in behandeling",
    authorization_pending_description:
      "Voltooi de toestemming in de bankapp of op desktop.",
    authorization_expires_at: "Verloopt om",
    authorization_expired: "Verzoek verlopen.",
    continue_authorization: "Autorisatie voortzetten",
    retry_authorization: "Opnieuw proberen",
    retry_authorization_loading: "Starten...",
    retry_authorization_failed: "Kon autorisatie niet starten.",
    authorization_missing_link: "Autorisatielink is niet beschikbaar.",
    authorization_rejected_title: "Autorisatie geweigerd",
    authorization_rejected_description:
      "De bank heeft het toestemmingsverzoek geweigerd. Je kunt het opnieuw proberen.",
    authorization_details_cta: "Bekijk details",
    authorization_details_title: "Autorisatiedetails",
    authorization_details_description:
      "Technische Yapily-informatie voor deze toestemmingspoging.",
    authorization_details_status: "Status",
    authorization_details_consent_id: "Toestemmings-ID",
    authorization_details_institution_consent_id: "Banktoestemmings-ID",
    authorization_details_tracing_id: "Tracing ID",
    authorization_details_phases: "Fasen",
    authorization_details_no_phases: "Geen fasen geregistreerd.",
    authorization_details_loading: "Details laden...",
    authorization_details_close: "Sluiten",
    authorization_details_failed: "Kan details niet laden.",
    revoke_consent: "Toestemming intrekken",
    revoke_consent_title: "Toestemming intrekken?",
    revoke_consent_description:
      "Dit trekt de toegang van MoneyLights tot je bankrekening in. Je kunt op elk moment opnieuw verbinden.",
    revoke_consent_confirm: "Intrekken",
    revoke_consent_cancel: "Annuleren",
    revoke_consent_success: "Toestemming ingetrokken.",
    revoke_consent_failed: "Kan toestemming niet intrekken.",
    connection_requires_reauth: "Deze verbinding vereist regelmatige herautorisatie.",
    please_update: "Update om gegevens te blijven importeren.",
    review_entries: "Bekijk invoer",
    update: "Bijwerken",
    new_bank_connection: "Nieuwe bankverbinding",
    list_of_supported_connections: "Lijst van ondersteunde verbindingen",
    yapily_connection_dashboard: "Yapily dashboard",
    about_openbanking: "Over OpenBanking",
    about_openbanking_description:
      "OpenBanking stelt u in staat om uw bankrekeningen veilig te verbinden met MoneyLights. Alle verbindingen zijn versleuteld en volgen de hoogste beveiligingsnormen (PSD2).",
    no_bank_connections_title: "Geen bankverbindingen",
    no_bank_connections_description:
      "Verbind uw bankrekening via OpenBanking om transacties automatisch te importeren en te analyseren.",
    accounts_title: "Rekeningen",
    account_default_name: "Bankrekening",
    account_name_placeholder: "Rekeningnaam",
    account_name_save: "Opslaan",
    account_name_cancel: "Annuleren",
    account_name_rename: "Hernoemen",
    account_name_saved: "Rekeningnaam bijgewerkt.",
    account_name_failed: "Kon rekeningnaam niet bijwerken.",
    account_visibility_label: "Zichtbaar in de app",
    account_visibility_hidden: "Verborgen",
    account_visibility_saved: "Accountzichtbaarheid bijgewerkt.",
    account_visibility_failed: "Accountzichtbaarheid kon niet worden bijgewerkt.",
    limit_reached: "Limiet van bankkoppelingen bereikt",
    upgrade: "Upgraden",
  },
  sv: {
    title: "Bankförbindelser",
    description: "Hantera dina bankkonton via OpenBanking",
    edit: "REDIGERA",
    updated_today_at: "Uppdaterad idag klockan",
    consent_created_at: "Samtycke skapat",
    consent_expires_at: "Samtycke löper ut",
    consent_reconfirmed_at: "Återbekräftad den",
    authorization_pending_title: "Auktorisering pågår",
    authorization_pending_description:
      "Slutför samtycket i bankappen eller på desktop.",
    authorization_expires_at: "Löper ut kl",
    authorization_expired: "Begäran har löpt ut.",
    continue_authorization: "Fortsätt auktorisering",
    retry_authorization: "Försök igen",
    retry_authorization_loading: "Startar...",
    retry_authorization_failed: "Kunde inte starta auktorisering.",
    authorization_missing_link: "Auktoriseringslänken är inte tillgänglig.",
    authorization_rejected_title: "Auktorisering avvisad",
    authorization_rejected_description:
      "Banken avvisade samtyckesförfrågan. Du kan försöka igen.",
    authorization_details_cta: "Visa detaljer",
    authorization_details_title: "Auktoriseringsdetaljer",
    authorization_details_description:
      "Teknisk Yapily-information för denna samtyckesbegäran.",
    authorization_details_status: "Status",
    authorization_details_consent_id: "Samtyckes-ID",
    authorization_details_institution_consent_id: "Bankens samtyckes-ID",
    authorization_details_tracing_id: "Tracing ID",
    authorization_details_phases: "Faser",
    authorization_details_no_phases: "Inga faser registrerade.",
    authorization_details_loading: "Läser in detaljer...",
    authorization_details_close: "Stäng",
    authorization_details_failed: "Kunde inte läsa in detaljer.",
    revoke_consent: "Återkalla samtycke",
    revoke_consent_title: "Återkalla samtycke?",
    revoke_consent_description:
      "Detta återkallar MoneyLights åtkomst till ditt bankkonto. Du kan ansluta igen när som helst.",
    revoke_consent_confirm: "Återkalla",
    revoke_consent_cancel: "Avbryt",
    revoke_consent_success: "Samtycke återkallat.",
    revoke_consent_failed: "Det gick inte att återkalla samtycket.",
    connection_requires_reauth: "Denna förbindelse kräver regelbunden återauktorisering.",
    please_update: "Uppdatera för att fortsätta importera data.",
    review_entries: "Granska poster",
    update: "Uppdatera",
    new_bank_connection: "Ny bankförbindelse",
    list_of_supported_connections: "Lista över stödda förbindelser",
    yapily_connection_dashboard: "Yapily-instrumentpanel",
    about_openbanking: "Om OpenBanking",
    about_openbanking_description:
      "OpenBanking låter dig säkert ansluta dina bankkonton till MoneyLights. Alla anslutningar är krypterade och följer högsta säkerhetsstandarder (PSD2).",
    no_bank_connections_title: "Inga bankförbindelser",
    no_bank_connections_description:
      "Anslut ditt bankkonto via OpenBanking för att automatiskt importera och analysera transaktioner.",
    accounts_title: "Konton",
    account_default_name: "Bankkonto",
    account_name_placeholder: "Kontonamn",
    account_name_save: "Spara",
    account_name_cancel: "Avbryt",
    account_name_rename: "Byt namn",
    account_name_saved: "Kontonamn uppdaterat.",
    account_name_failed: "Kunde inte uppdatera kontonamnet.",
    account_visibility_label: "Synlig i appen",
    account_visibility_hidden: "Dold",
    account_visibility_saved: "Kontots synlighet uppdaterades.",
    account_visibility_failed: "Det gick inte att uppdatera kontots synlighet.",
    limit_reached: "Gränsen för bankanslutningar är nådd",
    upgrade: "Uppgradera",
  },
  da: {
    title: "Bankforbindelser",
    description: "Administrer dine bankkonti via OpenBanking",
    edit: "REDIGER",
    updated_today_at: "Opdateret i dag kl.",
    consent_created_at: "Samtykke oprettet",
    consent_expires_at: "Samtykke udløber",
    consent_reconfirmed_at: "Bekræftet igen den",
    authorization_pending_title: "Godkendelse afventer",
    authorization_pending_description:
      "Fuldfør samtykket i bank-appen eller på desktop.",
    authorization_expires_at: "Udløber kl",
    authorization_expired: "Anmodningen er udløbet.",
    continue_authorization: "Fortsæt godkendelse",
    retry_authorization: "Prøv igen",
    retry_authorization_loading: "Starter...",
    retry_authorization_failed: "Kunne ikke starte godkendelsen.",
    authorization_missing_link: "Godkendelseslinket er ikke tilgængeligt.",
    authorization_rejected_title: "Godkendelse afvist",
    authorization_rejected_description:
      "Banken afviste samtykkeanmodningen. Du kan prøve igen.",
    authorization_details_cta: "Se detaljer",
    authorization_details_title: "Godkendelsesdetaljer",
    authorization_details_description:
      "Teknisk Yapily-information for denne samtykkeanmodning.",
    authorization_details_status: "Status",
    authorization_details_consent_id: "Samtykke-ID",
    authorization_details_institution_consent_id: "Bankens samtykke-ID",
    authorization_details_tracing_id: "Tracing ID",
    authorization_details_phases: "Faser",
    authorization_details_no_phases: "Ingen faser registreret.",
    authorization_details_loading: "Indlæser detaljer...",
    authorization_details_close: "Luk",
    authorization_details_failed: "Kunne ikke indlæse detaljer.",
    revoke_consent: "Tilbagekald samtykke",
    revoke_consent_title: "Tilbagekald samtykke?",
    revoke_consent_description:
      "Dette tilbagekalder MoneyLights' adgang til din bankkonto. Du kan forbinde igen når som helst.",
    revoke_consent_confirm: "Tilbagekald",
    revoke_consent_cancel: "Annuller",
    revoke_consent_success: "Samtykke tilbagekaldt.",
    revoke_consent_failed: "Kunne ikke tilbagekalde samtykket.",
    connection_requires_reauth: "Denne forbindelse kræver regelmæssig genautorisation.",
    please_update: "Opdater venligst for at fortsætte med at importere data.",
    review_entries: "Gennemse poster",
    update: "Opdater",
    new_bank_connection: "Ny bankforbindelse",
    list_of_supported_connections: "Liste over understøttede forbindelser",
    yapily_connection_dashboard: "Yapily-dashboard",
    about_openbanking: "Om OpenBanking",
    about_openbanking_description:
      "OpenBanking giver dig mulighed for sikkert at forbinde dine bankkonti til MoneyLights. Alle forbindelser er krypterede og følger de højeste sikkerhedsstandarder (PSD2).",
    no_bank_connections_title: "Ingen bankforbindelser",
    no_bank_connections_description:
      "Forbind din bankkonto via OpenBanking for automatisk at importere og analysere transaktioner.",
    accounts_title: "Konti",
    account_default_name: "Bankkonto",
    account_name_placeholder: "Kontonavn",
    account_name_save: "Gem",
    account_name_cancel: "Annuller",
    account_name_rename: "Omdøb",
    account_name_saved: "Kontonavn opdateret.",
    account_name_failed: "Kunne ikke opdatere kontonavnet.",
    account_visibility_label: "Synlig i appen",
    account_visibility_hidden: "Skjult",
    account_visibility_saved: "Kontosynlighed opdateret.",
    account_visibility_failed: "Kunne ikke opdatere kontosynlighed.",
    limit_reached: "Grænsen for bankforbindelser er nået",
    upgrade: "Opgrader",
  },
  fi: {
    title: "Pankkiyhteydet",
    description: "Hallitse pankkitilejäsi OpenBankingin kautta",
    edit: "MUOKKAA",
    updated_today_at: "Päivitetty tänään klo",
    consent_created_at: "Suostumus luotu",
    consent_expires_at: "Suostumus vanhenee",
    consent_reconfirmed_at: "Vahvistettu uudelleen",
    authorization_pending_title: "Valtuutus kesken",
    authorization_pending_description:
      "Viimeistele suostumus pankkisovelluksessa tai työpöydällä.",
    authorization_expires_at: "Vanhenee klo",
    authorization_expired: "Pyyntö vanhentui.",
    continue_authorization: "Jatka valtuutusta",
    retry_authorization: "Yritä uudelleen",
    retry_authorization_loading: "Käynnistetään...",
    retry_authorization_failed: "Valtuutusta ei voitu käynnistää.",
    authorization_missing_link: "Valtuutuslinkki ei ole saatavilla.",
    authorization_rejected_title: "Valtuutus hylätty",
    authorization_rejected_description:
      "Pankki hylkäsi suostumuspyynnön. Voit yrittää uudelleen.",
    authorization_details_cta: "Näytä tiedot",
    authorization_details_title: "Valtuutuksen tiedot",
    authorization_details_description:
      "Yapilyn tekniset tiedot tästä suostumusyrityksestä.",
    authorization_details_status: "Tila",
    authorization_details_consent_id: "Suostumus-ID",
    authorization_details_institution_consent_id: "Pankin suostumus-ID",
    authorization_details_tracing_id: "Tracing ID",
    authorization_details_phases: "Vaiheet",
    authorization_details_no_phases: "Vaiheita ei ole.",
    authorization_details_loading: "Ladataan tietoja...",
    authorization_details_close: "Sulje",
    authorization_details_failed: "Tietojen lataus epäonnistui.",
    revoke_consent: "Peruuta suostumus",
    revoke_consent_title: "Peruutetaanko suostumus?",
    revoke_consent_description:
      "Tämä peruuttaa MoneyLightsin pääsyn pankkitilillesi. Voit yhdistää uudelleen milloin tahansa.",
    revoke_consent_confirm: "Poista",
    revoke_consent_cancel: "Peruuta",
    revoke_consent_success: "Suostumus peruutettu.",
    revoke_consent_failed: "Suostumusta ei voitu peruuttaa.",
    connection_requires_reauth: "Tämä yhteys vaatii säännöllistä uudelleenvaltuutusta.",
    please_update: "Päivitä jatkaaksesi tietojen tuomista.",
    review_entries: "Tarkista merkinnät",
    update: "Päivitä",
    new_bank_connection: "Uusi pankkiyhteys",
    list_of_supported_connections: "Luettelo tuetuista yhteyksistä",
    yapily_connection_dashboard: "Yapily-hallintapaneeli",
    about_openbanking: "Tietoa OpenBankingista",
    about_openbanking_description:
      "OpenBanking mahdollistaa pankkitiliesi turvallisen yhdistämisen MoneyLightsiin. Kaikki yhteydet on salattu ja ne noudattavat korkeimpia tietoturvastandardeja (PSD2).",
    no_bank_connections_title: "Ei pankkiyhteyksiä",
    no_bank_connections_description:
      "Yhdistä pankkitilisi OpenBankingin kautta, jotta voit tuoda ja analysoida tapahtumat automaattisesti.",
    accounts_title: "Tilit",
    account_default_name: "Pankkitili",
    account_name_placeholder: "Tilin nimi",
    account_name_save: "Tallenna",
    account_name_cancel: "Peruuta",
    account_name_rename: "Nimeä uudelleen",
    account_name_saved: "Tilin nimi päivitetty.",
    account_name_failed: "Tilin nimen päivitys epäonnistui.",
    account_visibility_label: "Näkyy sovelluksessa",
    account_visibility_hidden: "Piilotettu",
    account_visibility_saved: "Tilin näkyvyys päivitetty.",
    account_visibility_failed: "Tilin näkyvyyttä ei voitu päivittää.",
    limit_reached: "Pankkiyhteyksien raja on saavutettu",
    upgrade: "Päivitä",
  },
};
